import { DictionaryItem } from '../types/coreTypes';

export const getSortIndex = (
  name: string,
  ordering: DictionaryItem[],
) => ordering.find((el) => el.label === name)?.value;
